import React, { useEffect, useState } from "react"
import {
  Card,
  CardHeader,
  Avatar,
  CardMedia,
  CardActionArea,
  Grow,
  Box
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import cloudinary from "cloudinary-core"
import { useHistory } from "react-router-dom"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import noPostsImg from "assets/no-posts-img.svg"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const AppCard = ({ classes, post }) => {
  const history = useHistory()
  const {
    id,
    first_name: firstName,
    last_name: lastName,
    image,
    profile_image: profileImage,
    title_value: titleValue
  } = post
  const [uploadType, setUploadType] = useState(null)
  const [source, setSource] = useState(null)

  useEffect(() => {
    const fileObj = JSON.parse(image)
    setUploadType(fileObj.resource_type)
    // setTimeout(() => {
    if (fileObj.resource_type === "video") {
      setSource(
        cl.video_url(`${fileObj.public_id}.jpg`, {
          startOffset: "1"
        })
      )
    } else {
      setSource(
        cl.url(fileObj.public_id, {
          width: 600,
          height: 600,
          crop: "fill",
          gravity: "auto"
        })
      )
    }
    // }, 2000)
  }, [image])

  const handleCardClick = id => {
    history.push({
      pathname: `/app/post/`,
      state: { post }
    })
  }
  return (
    <Grow in timeout={500} style={{ transformOrigin: "50% 50%" }}>
      <Card className={classes.root}>
        <CardHeader
          className={classes.header}
          avatar={
            <Avatar
              aria-label="recipe"
              className={classes.avatar}
              src={
                profileImage &&
                cl.url(JSON.parse(profileImage).public_id, {
                  width: 150,
                  crop: "scale"
                })
              }
            >
              {firstName ? firstName.split("").splice(0, 1) : ""}
              {lastName ? lastName.split("").splice(0, 1) : ""}{" "}
            </Avatar>
          }
          title={`${firstName} ${lastName}`}
          subheader={titleValue ? titleValue : ""}
        />
        <CardActionArea onClick={() => handleCardClick(id)}>
          {uploadType && (
            <CardMedia
              // className={uploadType === "image" ? classes.image : classes.video}
              className={classes.cardMedia}
              // component={uploadType === "video" ? "video" : "img"}
              component={"div"}
              controls={uploadType === "video"}
              // src={source}
              // title=""
              // preload="metadata"
              // playsInline="playsinline"
            >
              <img
                className={classes.image}
                src={source ? source : noPostsImg}
                alt="Post"
                onError={e => (e.target.src = noPostsImg)}
              />
              {uploadType === "video" && (
                <Box className={classes.iconContainer}>
                  <PlayCircleFilledIcon className={classes.playIcon} />
                </Box>
              )}
            </CardMedia>
          )}
        </CardActionArea>
      </Card>
    </Grow>
  )
}

export default withStyles(styles)(AppCard)



// WEBPACK FOOTER //
// ./src/components/AppCard/index.js